const getStatusSettings = () => ({
    items: {
        open: { id: 'open', name: 'offen' },
        email_sent: { id: 'email_sent', name: 'Email gesendet'},
        movie_select: { id: 'movie_select', name: 'Filmauswahl'},
        booked: { id: 'booked', name: 'gebucht'},
        closed: { id: 'closed', name: 'geschlossen' },
        undefined: { id: 'undefined', name: 'undefiniert'}
    },
    order: ['open', 'email_sent', 'movie_select', 'booked', 'closed']
})

export default getStatusSettings;